class CheckboxAccount extends HTMLElement {
	constructor() {
		super();
		this.seeMoreButtons = [];
		this.type = this.getAttribute('type');
		if (!this.type) this.type = 'checkbox';
	}

	connectedCallback() {
		this.seeMoreButtons = this.querySelectorAll('[data-see-more]');
		this.attachEventListeners();

		if (this.type === 'radio') {
			this.handleRadioInputChange();
		}
	}

	disconnectedCallback() {
		this.removeEventListeners();
	}

	attachEventListeners() {
		this.seeMoreButtons.forEach(button => {
			button.addEventListener('click', this.handleSeeMoreClick.bind(this));
		});
	}

	removeEventListeners() {
		this.seeMoreButtons.forEach(button => {
			button.removeEventListener('click', this.handleSeeMoreClick);
		});
	}

	handleSeeMoreClick(event) {
		const button = event.currentTarget;
		const container = button.closest('[data-checkbox-container]');
		const hiddenItems = container.querySelectorAll('[data-hidden-item]');

		hiddenItems.forEach(item => {
			item.classList.toggle('hidden');
		});

		const isHidden = hiddenItems[0].classList.contains('hidden');
		button.textContent = isHidden
			? window.accountStrings.seeAll
			: window.accountStrings.showLess;
	}

	handleRadioInputChange() {
		const inputWrappers = this.querySelectorAll('.checkbox-account__item');
		inputWrappers.forEach(inputWrapper => {
			inputWrapper.addEventListener('click', this.handleRadioChange.bind(this, inputWrapper));
		});
	}

	handleRadioChange(inputWrapper) {
		const input = inputWrapper.querySelector('input');
		const inputTargetId = input?.getAttribute('id');
		const inputs = this.querySelectorAll('.checkbox-account__item input');
		inputs.forEach(input => {
			input.checked = false;
		});
		const currentInput = this.querySelector(`#${inputTargetId}`);
		currentInput.checked = true;
	}
}

if (!customElements.get('c-checkbox-account')) {
	customElements.define('c-checkbox-account', CheckboxAccount);
}
